import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

const AddEntityForm = ({
  setShowAddEntityForm,
  setFormSubmittedSuccessfully
}) => {

  const [entityName, setEntityName] = useState("");
  const [showOptionalFields, setShowOptionalFields] = useState(false);
  const [annualClients, setAnnualClients] = useState();
  const [infractionSeverity, setInfractionSeverity] = useState("");
  const [quarterComplaintSeverity, setQuarterComplaintSeverity] = useState("");
  const [quarterSentimentAnalysis, setQuarterSentimentAnalysis] = useState("");
  const [inspectionResult, setInspectionResult] = useState("");
  const [reviewDate, setReviewDate] = useState("");
  const [reviewAdded, setReviewAdded] = useState(false);

  const createEntityAPI = process.env.REACT_APP_CREATE_ENTITY;

  const infractionSeverityOptions = [
    {
      label: "none",
      value: "none"
    },
    {
      label: "minor",
      value: "minor"
    },
    {
      label: "major",
      value: "major"
    },
  ]

  const quarterComplaintSeverityOptions = [
    {
      label: "none",
      value: "none"
    },
    {
      label: "minor",
      value: "minor"
    },
    {
      label: "major",
      value: "major"
    },
  ]

  const quarterSentimentAnalysisOptions = [
    {
      label: "none",
      value: "none"
    },
    {
      label: "flagged",
      value: "flagged"
    },
  ]

  const inspectionResultOptions = [
    {
      label: "none",
      value: "none"
    },
    {
      label: "pass",
      value: "pass"
    },
    {
      label: "fail",
      value: "fail"
    },
  ]

  const resetAddEntityForm = () => {
    setEntityName("");
    setShowOptionalFields(false);
    setAnnualClients();
    setInfractionSeverity("");
    setQuarterComplaintSeverity("");
    setQuarterSentimentAnalysis("");
    setInspectionResult("");
    setReviewDate("");
    setReviewAdded(false);
  }

  const handleEntityNameChange = (e) => {
    setEntityName(e.target.value);
  }

  const handleAnnualClientChange = (e) => {
    setAnnualClients(e.target.value);
  }

  const handleInfractionSeveritySelect = (selected) => {
    setInfractionSeverity(selected.value);
  }
  
  const handleQuarterComplaintSeveritySelect = (selected) => {
    setQuarterComplaintSeverity(selected.value);
  }
  
  const handleQuarterSentimentAnalysisSelect = (selected) => {
    setQuarterSentimentAnalysis(selected.value);
  }
  
  const handleInspectionResultSelect = (selected) => {
    setInspectionResult(selected.value);
  }

  const handleDateChange = (e) => {
    setReviewDate(e.target.value);
  }

  const handleCreateEntityFormSubmit = (e) => {
    e.preventDefault();
    let fields = {};
    let apiURL = createEntityAPI;
    if(reviewAdded) {
      fields.annualClients = annualClients;
      fields.infractionSeverity = infractionSeverity;
      fields.quarterComplaintSeverity = quarterComplaintSeverity;
      fields.quarterSentimentAnalysis = quarterSentimentAnalysis;
      fields.inspectionResult = inspectionResult;
      fields.reviewDate = reviewDate;
      apiURL = apiURL + `/${entityName}/review`;
    } else {
      fields.name = entityName;
    }
    apiURL = apiURL + `/create`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fields)
    };
    // console.log("API and request options are : ", apiURL, requestOptions);
    fetch(apiURL, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        toast.success("Form submitted successfully!");
        console.log(result.message);
        setFormSubmittedSuccessfully(true);
      })
      .catch((error) => {
        toast.error("Form submission failed. Try again!");
        console.error(error.message);
      });
    setShowAddEntityForm(false);
  }

  // useEffect(() => {
  //   console.log("Annual Clients entered is: ", annualClients);
  // }, [annualClients])
  // useEffect(() => {
  //   console.log("Infraction severity selected is: ", infractionSeverity);
  // }, [infractionSeverity])
  // useEffect(() => {
  //   console.log("quarter Complaint Severity selected is: ", quarterComplaintSeverity);
  // }, [quarterComplaintSeverity])
  // useEffect(() => {
  //   console.log("quarter Sentiment Analysis selected is: ", quarterSentimentAnalysis);
  // }, [quarterSentimentAnalysis])
  // useEffect(() => {
  //   console.log("inspection Result selected is: ", inspectionResult);
  // }, [inspectionResult])
  // useEffect(() => {
  //   console.log("Review Date selected is: ", reviewDate);
  // }, [reviewDate])

  useEffect(() => {
    const currentDate = new Date().toISOString().split('T')[0];
    setReviewDate(currentDate);
  }, []);

  return (
    <form  onSubmit={handleCreateEntityFormSubmit}>
      <div className="add-entity-form enrollment-form-container">
        <div className="enrollment-form-wrapper">
          <h3 className="enrollment-form-head">Add Entity Form<span className="enrollment-form-close-btn" onClick={() => {setShowAddEntityForm(false); resetAddEntityForm(); setShowOptionalFields(false)}}>&#x2715;</span></h3>
          <div className="enrollment-form-body d-flex flex-column align-items-center gap-0">
            <label>
              Entity Name<br></br>
              <input className="add-entity-select" type="text" value={entityName} onChange={handleEntityNameChange} required></input>
            </label>
            {!showOptionalFields && <div className="add-entity-optional-form mt--40 d-flex flex-column align-items-center justify-content-center">
              <small>Optional</small>
              <button className="edu-btn btn-small lh-1 mt-2" onClick={() => {setShowOptionalFields(true); setReviewAdded(true);}}>+ Add Review</button>
            </div>}
            {showOptionalFields && <>
              <h5 className="mt-5 mb-0">Review Details</h5>
              <label>
              Annual Clients<br></br>
              <input
                className="add-entity-select"
                type="number"
                min="0"
                value={annualClients}
                onChange={handleAnnualClientChange}
                required={showOptionalFields}
              />
            </label>
            <label className="mt-4">
              Infraction Severity
              <Select
                className="basic-single add-entity-select"
                placeholder="Select or search by typing..."
                isClearable="true"
                name="clientName"
                required={showOptionalFields}
                onChange={handleInfractionSeveritySelect}
                options={infractionSeverityOptions}
              />
            </label>
            <label className="mt-4">
              Quarter Complaint Severity
              <Select
                className="basic-single add-entity-select"
                placeholder="Select or search by typing..."
                isClearable="true"
                name="clientName"
                required={showOptionalFields}
                onChange={handleQuarterComplaintSeveritySelect}
                options={quarterComplaintSeverityOptions}
              />
            </label>
            <label className="mt-4">
              Quarter Sentiment Analysis
              <Select
                className="basic-single add-entity-select"
                placeholder="Select or search by typing..."
                isClearable="true"
                name="clientName"
                required={showOptionalFields}
                onChange={handleQuarterSentimentAnalysisSelect}
                options={quarterSentimentAnalysisOptions}
              />
            </label>
            <label className="mt-4">
              Inspection Result
              <Select
                className="basic-single add-entity-select"
                placeholder="Select or search by typing..."
                isClearable="true"
                name="clientName"
                required={showOptionalFields}
                onChange={handleInspectionResultSelect}
                options={inspectionResultOptions}
              />
            </label>
            <label className="mt-4 mb-5">
              Date<br></br>
              <input type="date" className="add-entity-select" name="date" onChange={handleDateChange} value={reviewDate}></input>
            </label>

            </>}
          </div>
          <div className="enrollment-form-footer">
            <button className='edu-btn btn-bg-alt' onClick={() => {setShowAddEntityForm(false); resetAddEntityForm(); setShowOptionalFields(false)}}>Cancel</button>
            <button className='edu-btn btn-secondary' type="submit">Submit</button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default AddEntityForm;